export const getObjectByProperty = (
  objects: any[],
  propertyName: string,
  propertyValue: string
) => {
  const ret = objects.find((obj) => obj[propertyName] === propertyValue);
  return ret?.label;
};


export const sortTableField = (
  list: any[],
  sortColumn: string | null | undefined,
  sortDirection: string
) => {
  return list.sort((a, b) => {
    if (sortColumn) {
      const aValue = a[sortColumn];
      const bValue = b[sortColumn];

      if (typeof aValue === "number" && typeof bValue === "number") {
        return sortDirection === "asc" ? aValue - bValue : bValue - aValue;
      } else {
        const aStr = String(aValue).toLowerCase();
        const bStr = String(bValue).toLowerCase();
        return sortDirection === "asc"
          ? aStr.localeCompare(bStr)
          : bStr.localeCompare(aStr);
      }
    }
    return 0;
  });
};


export const isString = (value: any): boolean => {
  return typeof value === "string";
};